<template>
  <div class="common-result">
    <div class="transfer-result">
      <div class="transfer-result-back"></div>
      <img v-if="status === 'success' || status === 'complete'" src="@/assets/image/transfer/transfer-success.png" alt="">
      <img v-if="status === 'fail'" src="@/assets/image/transfer/transfer-fail.png" alt="">
    </div>
    <div class="transfer-result-tip">
      {{ $t(tipMessage) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: { // success fail complete
      type: String,
      default: 'success'
    },
    tipMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
  .common-result {
    .transfer-result-tip {
      text-align: center;
      color: #131523;
      font-size: 16px;
      margin: 20px 0 40px;
    }

    .transfer-result {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      position: relative;

      .transfer-result-back {
        width: 100%;
        height: 123px;
        background: linear-gradient(180deg, rgba(251, 252, 254, 0) 0%, #F6F7FC 100%);
        border-radius: 10px;
        position: absolute;
        left: 0;
        top: -14px;
      }

      img {
        position: relative;
        z-index: 2;
        width: 220px;
        height: 150px;
        margin-bottom: 20px;
      }
    }
  }
</style>
